import React, { useState, memo } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Container,
  Row,
} from "reactstrap";
import { ImageQuestionType } from "../types";
import { copyTextToClipboard } from "../utils/copyToClipboard";
import Toastr from "toastr";
import { ExpandMore, ExpandLess, LiveHelp } from "@material-ui/icons";

const SingleQuestionImage: React.FC<{
  question: ImageQuestionType;
  defaultOpen?: boolean;
}> = ({ question, defaultOpen = false }) => {
  const [collapsed, setCollapsed] = useState(!defaultOpen);

  const handleCopyAllOutput = () => {
    if (!question.messages || !question.messages.text) return;

    const responses = question.messages.text;
    copyTextToClipboard(responses);
    Toastr.success("Copied to clipboard");
  };

  return (
    <Container fluid className="mb-4">
      <Card className="shadow">
        <CardHeader>
          <h4 style={{ display: "inline" }}>
            <LiveHelp className="text-success" /> {question.question}
          </h4>
          <span className="float-right">
            <Button
              size="sm"
              color="primary"
              onClick={() => setCollapsed(!collapsed)}
            >
              {collapsed ? <ExpandMore /> : <ExpandLess />}
            </Button>
          </span>
          {question.cost && (
            <>
              <br />
              <span
                style={{
                  fontSize: "0.8rem",
                }}
              >
                Cost: <span>${(question.cost || 0).toFixed(4)}</span>
              </span>
              &nbsp;
            </>
          )}
        </CardHeader>
        <Collapse isOpen={!collapsed}>
          <CardBody>
            <Row>
              <Col className="order-xl-1">
                {question.messages && question.messages.text.length > 0 && (
                  <Row className="ques-resp-col">
                    <Col
                      xs="12"
                      className="ques-resp-col"
                      style={{
                        overflowY: "auto",
                        maxHeight: "350px",
                      }}
                    >
                      <h2
                        className="row-h2"
                        style={{
                          position: "sticky",
                          top: "0",
                          background: "white",
                        }}
                      >
                        Output&nbsp;
                        <small>
                          (
                          {
                            question.messages.text
                              .split(" ")
                              .filter((w) => w.length > 0).length
                          }{" "}
                          words )
                        </small>
                        {question.messages &&
                          question.messages.text.length > 0 && (
                            <small className="ml-2">
                              <i
                                className="fas fa-copy"
                                onClick={handleCopyAllOutput}
                                style={{ cursor: "pointer" }}
                              />
                            </small>
                          )}
                      </h2>
                      <ul>{question.messages.text}</ul>
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
          </CardBody>
        </Collapse>
      </Card>
    </Container>
  );
};

export default memo(SingleQuestionImage);
